// extracted by mini-css-extract-plugin
export default {"main":"app_main__nXLxf","container":"app_container__pGEBw"};